
<div>
  <p>{{message | translate}}</p>

  <form nz-form [formGroup]="formGroup">

    <nz-form-item>
      <nz-form-label [nzSpan]="6">{{'verification-requests/reject/reason' | translate}}</nz-form-label>
      <nz-form-control [nzSpan]="18">
        <nz-select formControlName="reasonId" [nzSize]="'default'">
          @for (option of '/VerificationRequestRejectionReasons/page/0' | api | async; track option) {
            <nz-option [nzLabel]="option.name" [nzValue]="option.id"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="6">{{'verification-requests/reject/reason-note' | translate}}</nz-form-label>
      <nz-form-control [nzSpan]="18">
        <textarea nz-input formControlName="note" rows="3"></textarea>
      </nz-form-control>
    </nz-form-item>
  </form>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-danger" [disabled]="!formGroup.controls.reasonId.value" (click)="ok()">{{'verification-requests/reject' | translate}}</button>
  <button type="button" class="btn btn-secondary" (click)="close()">{{'common/buttons/cancel' | translate}}</button>
</div>
